import { useEffect, useState } from 'react';
import { redirect, useLocation } from 'react-router-dom';
import { ComponenteSpinner } from '../pages/adminComponents/ComponenteSpinner';
import { loadState, clearState, fromBase64url } from '../auth/authUtils';

export const GoogleCallback = () => {
  useEffect(() => {
    (async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const stateRaw = params.get('state');

      const saved = parseState(stateRaw); // { n, t, r }
      const goBack = () => {
        // regresar al sitio invocador sin parámetros adicionales
        // const ret = saved?.r;
        // if (ret) window.location.replace(ret);
        // else window.location.replace('/'); // fallback local

        const noAuth = sessionStorage.getItem("redirect_after_no_auth");
          if (noAuth) {
              sessionStorage.removeItem("redirect_after_no_auth");
              window.location.href = noAuth;
          } else {
              window.location.replace('/');
          }
      };

      // 1) Validaciones mínimas
      if (!code || !stateRaw || !saved?.r) {
        goBack();
        return;
      }

      // 2) Intercambio con backend
      try {
        const res = await fetch(`${process.env.REACT_APP_API_EXT}/auth/google/exchange`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          // credentials: 'omit', // por defecto; no enviamos cookies
          body: JSON.stringify({
            code,
            state: stateRaw,
            redirect_uri: `${window.location.origin}/oauth2/callback/google`,
          }),
        });

        if (!res.ok) {
          goBack(); // error HTTP -> regresar sin nada
          return;
        }

        const api = await res.json();
        const data = api?.data ?? api;

        //if verificando api.statuscode (renombrar de ser necesario)

        const token = data?.jwtToken;
        const dest = data?.redirect;

        if (!token || !dest) {
          goBack(); // no hay token o no hay destino -> regresar
          return;
        }

        // 3) Éxito: enviar token al sitio invocador vía POST auto-submit
        const email = ""
        postAndRedirect(dest, { token, email });

      } catch (e) {
        goBack(); // error de red/parseo -> regresar
      }
    })();
  }, []);

  return <ComponenteSpinner />;
}

function base64UrlDecode(s) {
  if (!s) return '';
  let t = s.replace(/-/g, '+').replace(/_/g, '/');
  const pad = t.length % 4;
  if (pad) t += '='.repeat(4 - pad);
  try { return atob(t); } catch { return ''; }
}
function parseState(b64) {
  try { return JSON.parse(base64UrlDecode(b64)); } catch { return null; }
}
function postAndRedirect(url, payload) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  form.acceptCharset = 'UTF-8'; // ayuda a parsers del lado receptor
  Object.entries(payload).forEach(([k, v]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = k;
    input.value = v ?? '';
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}

export default GoogleCallback;
